import React from "react";
import hymnData from "../../../../assets/hymns.json";
import { Hymn } from "models/Hymn";
import HymnRow from "./HymnRow";
import "./HymnTable.scss";

function HymnTable() {
  const hymns: Array<Hymn> = hymnData;

  return (
    <table className="hymnTable">
      <tr style={{ backgroundColor: "#d9edf7" }}>
        <th> </th>
        <th>#</th>
        <th>Title</th>
        <th>Tune</th>
      </tr>
      {hymns.map((hymn, index) => (
        <HymnRow hymn={hymn} isEven={index % 2 === 0} />
      ))}
    </table>
  );
}

export default HymnTable;
